(function () {

  const targetSections = [
    "612661305098109539", // PAGE 1 (tu l’as déjà)
    // AJOUTE ICI les 2 autres IDs SANS gp_section_
  ];

  function applyFont() {
    targetSections.forEach(id => {
      const sections = document.querySelectorAll(`[id*="${id}"]`);
      
      sections.forEach(section => {
        section.querySelectorAll("*").forEach(el => {
          el.style.setProperty("font-family", "Montserrat, sans-serif", "important");
        });
      });
    });
  }

  // 🔥 1. Appliquer direct
  applyFont();

  // 🔥 2. Observer les changements DOM (clé du problème)
  const observer = new MutationObserver(() => {
    applyFont();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();